import types from './types'

export const actions = {
  setCustomer ({ commit }, payload) {
    commit(types.SET_CUSTOMER, payload)
  },

  setPurchaser ({ commit }, payload) {
    commit(types.SET_PURCHASER, payload)
  },

}
